export default {
  textarea: 'border border-[#CEDCEC] bg-color-bg !rounded-lg',
  textareaWarning: 'border-[#EEA236]',
  warningText: 'text-[12px] text-[#EEA236]',
};
